//  ----------------------------------------------------------------------------
//  Store config
//  ----------------------------------------------------------------------------
//
//  Store constant directory
//
//  -- Description
//  Source of truth for store config values
//

import { v4 } from "uuid";

//  -- Action types -------------------
export const ActionTypes = {
  base: {
    example: "BASE_EXAMPLE",
    exampleFail: "BASE_EXAMPLE_FAIL",
    exampleSuccess: "BASE_EXAMPLE_SUCCESS",
  },

  activities: {
    updateActivitySequence: "UPDATE_ACTIVITY_SEQUENCE",

    listActivitiesByIdsSuccess: "LIST_ACTIVITIES_BY_IDS_SUCCESS",

    createActivity: "CREATE_ACTIVITY",
    createActivityFail: "CREATE_ACTIVITY_FAIL",
    createActivitySuccess: "CREATE_ACTIVITY_SUCCESS",

    updateActivites: "updateActivites",
    updateActivitesSuccess: "updateActivitesSuccess",
    updateActivitesFail: "updateActivitesFail",

    deleteActivites: "updateActivites",
    deleteActivitesSuccess: "deleteActivitesSuccess",
    deleteActivitesFail: "deleteActivitesFail",

    getActivity: "GET_ACTIVITY",
    getActivityFail: "GET_ACTIVITY_FAIL",
    getActivitySuccess: "GET_ACTIVITY_SUCCESS",

    listActivities: "LIST_ACTIVITIES",
    listActivitiesFail: "LIST_ACTIVITIES_FAIL",
    listActivitiesSuccess: "LIST_ACTIVITIES_SUCCESS",

    listChapterActivities: "LIST_CHAPTER_ACTIVITIES",
    listChapterActivitiesFail: "LIST_CHAPTER_ACTIVITIES_FAIL",
    listChapterActivitiesSuccess: "LIST_CHAPTER_ACTIVITIES_SUCCESS",
    deleteEnageActivitySuccess: "deleteEnageActivitySuccess",

    listShareListSuccess: "LIST_SHARE_LIST_SUCCESS",
  },
  assignmenent: {
    listAssignmentByUser: "LIST_ASSIGNMENT_BY_USER",
    listAssignmentByUserSuccess: "LIST_ASSIGNMENT_BY_USER_SUCCESS",
    listAssignmentByUserFail: "LIST_ASSIGNMENT_BY_USER_FAIL",

    createCustomAssignment: "CREATE_CUSTOM_ASSIGNMENT",
    createCustomAssignmentFail: "CREATE_CUSTOM_ASSIGNMENT_FAIL",
    createCustomAssignmentSuccess: "CREATE_CUSTOM_ASSIGNMENT_SUCCESS",

    updateCustomAssignment: "UPDATE_CUSTOM_ASSIGNMENT",
    updateCustomAssignmentFail: "UPDATE_CUSTOM_ASSIGNMENT_FAIL",
    updateCustomAssignmentSuccess: "UPDATE_CUSTOM_ASSIGNMENT_SUCCESS",

    deleteCustomAssignment: "DELETE_CUSTOM_ASSIGNMENT",
    deleteCustomAssignmentFail: "DELETE_CUSTOM_ASSIGNMENT_FAIL",
    deleteCustomAssignmentSuccess: "DELETE_CUSTOM_ASSIGNMENT_SUCCESS",
  },

  ownGraphicOrganizer: {
    createOwnGraphicOrganizer: "CREATE_OWN_GRAPHIC_ORGANIZER",
    createOwnGraphicOrganizerSuccess: "CREATE_OWN_GRAPHIC_ORGANIZER_SUCCESS",
    createOwnGraphicOrganizerFail: "CREATE_OWN_GRAPHIC_ORGANIZER_FAIL",

    updateOwnGraphicOrganizer: "UPDATE_OWN_GRAPHIC_ORGANIZER",
    updateOwnGraphicOrganizerSuccess: "UPDATE_OWN_GRAPHIC_ORGANIZER_SUCCESS",
    updateOwnGraphicOrganizerFail: "UPDATE_OWN_GRAPHIC_ORGANIZER_FAIL",

    listOwnGraphicOrganizer: "LIST_OWN_GRAPHIC_ORGANIZER",
    listOwnGraphicOrganizerSuccess: "LIST_OWN_GRAPHIC_ORGANIZER_SUCCESS",
    listOwnGraphicOrganizerFail: "LIST_OWN_GRAPHIC_ORGANIZER_FAIL",

    deleteOwnGraphicOrganizer: "DELETE_OWN_GRAPHIC_ORGANIZER",
    deleteOwnGraphicOrganizerSuccess: "DELETE_OWN_GRAPHIC_ORGANIZER_SUCCESS",
    deleteOwnGraphicOrganizerFail: "DELETE_OWN_GRAPHIC_ORGANIZER_FAIL",
  },

  userBooks: {
    listUserBooks: "LIST_USERBOOKS",
    listUserBooksFail: "LIST_USERBOOKS_FAIL",
    listUserBooksSuccess: "LIST_USERBOOKS_SUCCESS",
    setUserAllowedBooks: "SET_USER_ALLOWED_BOOKS",
    updateUserAllowedBooks: "UPDATE_USER_ALLOWED_BOOKS",
  },

  books: {
    listBooks: "LIST_BOOKS",
    listBooksFail: "LIST_BOOKS_FAIL",
    listBooksSuccess: "LIST_BOOKS_SUCCESS",

    listAllBooks: "LIST_ALL_BOOKS",
    listAllBooksFail: "LIST_ALL_BOOKS_FAIL",
    listAllBooksSuccess: "LIST_ALL_BOOKS_SUCCESS",

    createBook: "createBook",
    createBookSuccess: "createBookSuccess",
    createBookFail: "createBookFail",

    updateBook: "updateBook",
    updateBookSuccess: "updateBookSuccess",
    updateBookFail: "updateBookFail",

    setBookOrder: "setBookOrder",
    setBookOrderSuccess: "setBookOrderSuccess",
    setBookOrderFail: "setBookOrderFail",

    listBooksByIdsSuccess: "listBooksByIdsSuccess",

    listBooksCover: "LIST_BOOKS_COVER",
    listBooksCoverFail: "LIST_BOOKS_COVER_FAIL",
    listBooksCoverSuccess: "LIST_BOOKS_COVER_SUCCESS",
  },
  bookmarks: {
    liastClassBookmarksSuccess: "liastClassBookmarksSuccess",
    liastClassBookmarksFail: "liastClassBookmarksFail",
    updateBookmarks: "updateBookmarks",
    createClassBookmarksSuccess: "createClassBookmarksSuccess",
    deleteBookmark: "deletebookmark",
  },
  bookUnits: {
    listUnits: "LIST_UNITS",
    listUnitsSuccess: "LIST_UNITS_SUCCESS",
    listUnitsFail: "LIST_UNITS_FAIL",
    updateUnits: "update_UNITS",
    updateUnitsSuccess: "update_UNITS_SUCCESS",
    updateUnitsFail: "update_UNITS_FAIL",

    setGoogleCoursesMap: "SET_GOOGLE_COURSE_MAP",
    updateGoogleCoursesMap: "UPDATE_GOOGLE_COURS_MAP"
  },
  tips: {
    listTipsBook: "LIST_TIPSBOOK",
    listTipsBookFail: "LIST_TIPSBOOK_FAIL",
    listTipsBookSuccess: "LIST_TIPSBOOK_SUCCESS",

    createTipsBook: "CREATE_TIPSBOOK",
    createTipsBookFail: "CREATE_TIPSBOOK_FAIL",
    createTipsBookSuccess: "CREATE_TIPSBOOK_SUCCESS",

    updateTipsBook: "UPDATE_TIPSBOOK",
    updateTipsBookFail: "UPDATE_TIPSBOOK_FAIL",
    updateTipsBookSuccess: "UPDATE_TIPSBOOK_SUCCESS",

    deleteTipsBook: "DELETE_TIPSBOOK",
    deleteTipsBookFail: "DELETE_TIPSBOOK_FAIL",
    deleteTipsBookSuccess: "DELETE_TIPSBOOK_SUCCESS",
  },

  auth: {
    userLogin: "USER_LOGIN",
    userLoginFail: "USER_LOGIN_FAIL",
    userLoginSuccess: "USER_LOGIN_SUCCESS",

    userLogout: "USER_LOGOUT",
    userLogoutFail: "USER_LOGOUT_FAIL",
    userLogoutSuccess: "USER_LOGOUT_SUCCESS",
    USER_LOGOUT_CLEAN_STORAGE: "USER_LOGOUT_CLEAN_STORAGE",
  },

  classes: {
    createClass: "CREATE_CLASS",
    createClassFail: "CREATE_CLASS_FAIL",
    createClassSuccess: "CREATE_CLASS_SUCCESS",

    getClass: "GET_CLASS",
    getClassFail: "GET_CLASS_FAIL",
    getClassSuccess: "GET_CLASS_SUCCESS",

    getClassByCode: "GET_CLASS_BY_CODE",
    getClassByCodeFail: "GET_CLASS_BY_CODE_FAIL",
    getClassByCodeSuccess: "GET_CLASS_BY_CODE_SUCCESS",

    listClasses: "LIST_CLASSES",
    listClassesFail: "LIST_CLASSES_FAIL",
    listClassesSuccess: "LIST_CLASSES_SUCCESS",

    listAllClasses: "LIST_ALL_CLASSES",
    listAllClassesFail: "LIST_ALL_CLASSES_FAIL",
    listAllClassesSuccess: "LIST_ALL_CLASSES_SUCCESS",

    listOrgClasses: "LIST_ORGANIZATION_CLASSES",
    listOrgClassesFail: "LIST_ORGANIZATION_CLASSES_FAIL",
    listOrgClassesSuccess: "LIST_ORGANIZATION_CLASSES_SUCCESS",

    listTeacherClasses: "LIST_TEACHER_CLASSES",
    listTeacherClassesFail: "LIST_TEACHER_CLASSES_FAIL",
    listTeacherClassesSuccess: "LIST_TEACHER_CLASSES_SUCCESS",

    updateClass: "UPDATE_CLASS",
    updateClassFail: "UPDATE_CLASS_FAIL",
    updateClassSuccess: "UPDATE_CLASS_SUCCESS",

    getClassAllTeacherSuccess: "GET_CLASS_ALL_TEACHER_SUCCESS",
  },

  classActivities: {
    listClassActivitiesForStudentWithIds: "LIST_CLASS_ACTIVITIES_FOR_STUDENT_WITH_IDS",
    createClassActivity: "CREATE_CLASS_ACTIVITY",
    createClassActivityFail: "CREATE_CLASS_ACTIVITY_FAIL",
    createClassActivitySuccess: "CREATE_CLASS_ACTIVITY_SUCCESS",
    createDeactivateByStudent: "CREATE_DEACTIVATE_BY_STUDENT",

    deleteClassActivity: "DELETE_CLASS_ACTIVITY",
    deleteClassActivityFail: "DELETE_CLASS_ACTIVITY_FAIL",
    deleteClassActivitySuccess: "DELETE_CLASS_ACTIVITY_SUCCESS",
    deleteMultiClassActivitySuccess: "DELETE_MULTI_CLASS_ACTIVITY_SUCCESS",

    listClassActivities: "LIST_CLASS_ACTIVITIES",
    listClassActivitiesFail: "LIST_CLASS_ACTIVITIES_FAIL",
    listClassActivitiesSuccess: "LIST_CLASS_ACTIVITIES_SUCCESS",

    updateClassActivity: "UPDATE_CLASS_ACTIVITY",
    updateClassActivityFail: "UPDATE_CLASS_ACTIVITY_FAIL",
    updateClassActivitySuccess: "UPDATE_CLASS_ACTIVITY_SUCCESS",
    updateClassActivitiesById: "UPDATE_CLASS_ACTIVITIES_BY_ID",
    updateClassActivitiesFromSchoologySocket: "UPDATE_CLASS_ACTIVITIES_FROM_SCHOOLOGY_SOCKET",
  },

  classQuizzes: {
    listClassQuizzesForStudentWithIds: "LIST_CLASS_QUIZZES_FOR_STUDENT_WITH_IDS",
    createClassQuiz: "CREATE_CLASS_QUIZ",
    createClassQuizFail: "CREATE_CLASS_QUIZ_FAIL",
    createClassQuizSuccess: "CREATE_CLASS_QUIZ_SUCCESS",

    deleteClassQuiz: "DELETE_CLASS_QUIZ",
    deleteClassQuizFail: "DELETE_CLASS_QUIZ_FAIL",
    deleteClassQuizSuccess: "DELETE_CLASS_QUIZ_SUCCESS",
    deleteMultiClassQuizSuccess: "DELETE_MULTI_CLASS_QUIZ_SUCCESS",

    listClassQuizzes: "LIST_CLASS_QUIZZES",
    listClassQuizzesFail: "LIST_CLASS_QUIZZES_FAIL",
    listClassQuizzesSuccess: "LIST_CLASS_QUIZZES_SUCCESS",

    updateClassQuiz: "UPDATE_CLASS_QUIZ",
    updateClassQuizFail: "UPDATE_CLASS_QUIZ_FAIL",
    updateClassQuizSuccess: "UPDATE_CLASS_QUIZ_SUCCESS",
    updateClassQuizById: "UPDATE_CLASS_QUIZ_BY_ID",
    updateClassQuizzesFromSchoologySocket: "UPDATE_CLASS_QUIZZES_FROM_SCHOOLOGY_SOCKET",
  },

  differentiation: {
    createDifferentiation: "CREATE_DIFFERENTIATION",
    createDifferentiationFail: "CREATE_DIFFERENTIATION_FAIL",
    createDifferentiationSuccess: "CREATE_DIFFERENTIATION_SUCCESS",
  },

  interactions: {
    createInteraction: "CREATE_INTERACTION",
    createInteractionFail: "CREATE_INTERACTION_FAIL",
    createInteractionSuccess: "CREATE_INTERACTION_SUCCESS",

    updateInteraction: "UPDATE_INTERACTION",
    updateInteractionFail: "UPDATE_INTERACTION_FAIL",
    updateInteractionSuccess: "UPDATE_INTERACTION_SUCCESS",

    deleteInteraction: "DELETE_INTERACTION",
    deleteInteractionFail: "DELETE_INTERACTION_FAIL",
    deleteInteractionSuccess: "DELETE_INTERACTION_SUCCESS",

    getInteraction: "GET_INTERACTION",
    getInteractionFail: "GET_INTERACTION_FAIL",
    getInteractionSuccess: "GET_INTERACTION_SUCCESS",

    listInteractions: "LIST_INTERACTIONS",
    listInteractionsFail: "LIST_INTERACTIONS_FAIL",
    listInteractionsSuccess: "LIST_INTERACTIONS_SUCCESS",

    listChapterInteractions: "LIST_CHAPTER_INTERACTIONS",
    listChapterInteractionsFail: "LIST_CHAPTER_INTERACTIONS_FAIL",
    listChapterInteractionsSuccess: "LIST_CHAPTER_INTERACTIONS_SUCCESS",

    listInteractionsByType: "LIST_INTERACTIONS_BY_TYPE",
    listInteractionsByTypeFail: "LIST_INTERACTIONS_BY_TYPE_FAIL",
    listInteractionsByTypeSuccess: "LIST_INTERACTIONS_BY_TYPE_SUCCESS",
  },
  instructions: {
    createInstructions: "CREATE_INSTRUCTIONS",
    createInstructionsFail: "CREATE_INSTRUCTIONS_FAIL",
    createInstructionsSuccess: "CREATE_INSTRUCTIONS_SUCCESS",

    updateInstructions: "UPDATE_INSTRUCTIONS",
    updateInstructionsFail: "UPDATE_INSTRUCTIONS_FAIL",
    updateInstructionsSuccess: "UPDATE_INSTRUCTIONS_SUCCESS",

    listInstructions: "LIST_INSTRUCTIONS",
    listInstructionsFail: "LIST_INSTRUCTIONS_FAIL",
    listInstructionsSuccess: "LIST_INSTRUCTIONS_SUCCESS",

    deleteInstructions: "DELETE_INSTRUCTIONS",
    deleteInstructionsFail: "DELETE_INSTRUCTIONS_FAIL",
    deleteInstructionsSuccess: "DELETE_INSTRUCTIONS_SUCCESS",
  },
  notes: {
    createNote: "CREATE_NOTE",
    createNoteFail: "CREATE_NOTE_FAIL",
    createNoteSuccess: "CREATE_NOTE_SUCCESS",

    deleteNote: "DELETE_NOTE",
    deleteNoteFail: "DELETE_NOTE_FAIL",
    deleteNoteSuccess: "DELETE_NOTE_SUCCESS",

    listNotes: "LIST_NOTES",
    listNotesFail: "LIST_NOTES_FAIL",
    listNotesSuccess: "LIST_NOTES_SUCCESS",

    listChapterNotes: "LIST_CHAPTER_NOTES",
    listChapterNotesFail: "LIST_CHAPTER_NOTES_FAIL",
    listChapterNotesSuccess: "LIST_CHAPTER_NOTES_SUCCESS",

    listClassNotes: "LIST_CLASS_NOTES",
    listClassNotesFail: "LIST_CLASS_NOTES_FAIL",
    listClassNotesSuccess: "LIST_CLASS_NOTES_SUCCESS",

    listNoteByBookFail: "LIST_BOOK_NOTES_FAIL",
    listNoteByBookSuccess: "LIST_BOOK_NOTES_SUCCESS",

    listOrgNotes: "LIST_ORGANIZATION_NOTES",
    listOrgNotesFail: "LIST_ORGANIZATION_NOTES_FAIL",
    listOrgNotesSuccess: "LIST_ORGANIZATION_NOTES_SUCCESS",

    listUserNotes: "LIST_USER_NOTES",
    listUserNotesFail: "LIST_USER_NOTES_FAIL",
    listUserNotesSuccess: "LIST_USER_NOTES_SUCCESS",

    updateNote: "UPDATE_NOTE",
    updateNoteFail: "UPDATE_NOTE_FAIL",
    updateNoteSuccess: "UPDATE_NOTE_SUCCESS",
  },

  organizations: {
    createOrganization: "CREATE_ORGANIZATION",
    createOrganizationFail: "CREATE_ORGANIZATION_FAIL",
    createOrganizationSuccess: "CREATE_ORGANIZATION_SUCCESS",

    getOrganization: "GET_ORGANIZATION",
    getOrganizationFail: "GET_ORGANIZATION_FAIL",
    getOrganizationSuccess: "GET_ORGANIZATION_SUCCESS",
    getOrganizationPermissionSuccess: "GET_ORGANIZATION_PERMISSION_SUCCESS",

    listDistricts: "LIST_DISTRICTS",
    listDistrictsFail: "LIST_DISTRICTS_FAIL",
    listDistrictsSuccess: "LIST_DISTRICTS_SUCCESS",

    listAllSchools: "LIST_ALL_SCHOOLS",
    listAllSchoolsFail: "LIST_ALL_SCHOOLS_FAIL",
    listAllSchoolsSuccess: "LIST_ALL_SCHOOLS_SUCCESS",

    listOrgsByParent: "LIST_ORGS_BY_PARENT",
    listOrgsByParentFail: "LIST_ORGS_BY_PARENT_FAIL",
    listOrgsByParentSuccess: "LIST_ORGS_BY_PARENT_SUCCESS",

    listOrganizations: "LIST_ORGANIZATIONS",
    listOrganizationsFail: "LIST_ORGANIZATIONS_FAIL",
    listOrganizationsSuccess: "LIST_ORGANIZATIONS_SUCCESS",

    listSchools: "LIST_SCHOOLS",
    listSchoolsFail: "LIST_SCHOOLS_FAIL",
    listSchoolsSuccess: "LIST_SCHOOLS_SUCCESS",

    updateDistrictsSuccess: "UPDATE_DISTRICTS_SUCCESS",

    updateOrganization: "UPDATE_ORGANIZATION",
    updateOrganizationFail: "UPDATE_ORGANIZATION_FAIL",
    updateOrganizationSuccess: "UPDATE_ORGANIZATION_SUCCESS",
  },
  orgTeacher: {
    listOrgTeacherData: "listOrgTeacherData",
    listOrgTeacherDataSuccess: "listOrgTeacherDataSuccess",
    listOrgTeacherDataFail: "listOrgTeacherDataFail",
  },
  distDashboardInfo: {
    setDistDashboardInfo: "setDistDashboardInfo",
    updateDistDashboardInfo: "updateDistDashboardInfo",
    clearDistDashboardInfo: "clearDistDashboardInfo",

    setExamsGraphData: "setExamsGraphData",
    updateExamsGraphData: "updateExamsGraphData",
    clearExamsGraphData: "clearExamsGraphData",


    setBookUsesGraphData: "setBookUsesGraphData",
    updateBookUsesGraphData: "updateBookUsesGraphData",
    clearBookUsesGraphData: "clearBookUsesGraphData",

    setContentExamGraphData : "setContentExamGraphData",
    updateContentExamGraphData : "updateContentExamGraphData",
    clearContentExamGraphData : "clearContentExamGraphData",
    
  },
  adminHomeInfo: {
    setAdminHomeInfo: "setAdminHomeInfo",
    updateAdminHomeInfo: "updateAdminHomeInfo",
  },
  quizzes: {
    createQuiz: "CREATE_QUIZ",
    createQuizFail: "CREATE_QUIZ_FAIL",
    createQuizSuccess: "CREATE_QUIZ_SUCCESS",

    updateQuiz: "updateQuiz",
    updateQuizSuccess: "updateQuizSuccess",
    updateQuizFail: "updateQuizFail",

    deleteQuiz: "deleteQuiz",
    deleteQuizSuccess: "deleteQuizSuccess",
    deleteQuizFail: "deleteQuizFail",

    getQuiz: "GET_QUIZ",
    getQuizFail: "GET_QUIZ_FAIL",
    getQuizSuccess: "GET_QUIZ_SUCCESS",

    listQuizzes: "LIST_QUIZZES",
    listQuizzesFail: "LIST_QUIZZES_FAIL",
    listQuizzesSuccess: "LIST_QUIZZES_SUCCESS",
    listQuizzesByIdsSuccess: "LIST_QUIZZES_BY_IDS_SUCCESS",
    listChapterQuizzes: "LIST_CHAPTER_QUIZZES",
    listChapterQuizzesFail: "LIST_CHAPTER_QUIZZES_FAIL",
    listChapterQuizzesSuccess: "LIST_CHAPTER_QUIZZES_SUCCESS",
  },

  submissions: {
    createSubmission: "CREATE_SUBMISSION",
    createSubmissionFail: "CREATE_SUBMISSION_FAIL",
    createSubmissionSuccess: "CREATE_SUBMISSION_SUCCESS",

    deleteUserSubmissions: "DELETE_USER_SUBMISSIONS",
    deleteUserSubmissionsFail: "DELETE_USER_SUBMISSIONS_FAIL",
    deleteUserSubmissionsSuccess: "DELETE_USER_SUBMISSIONS_SUCCESS",

    updateSubmissionInBatchSuccess:"updateSubmissionInBatchSuccess",

    deleteUserSubmissionsWithAssignment:
      "DELETE_USER_SUBMISSIONS_WITH_ASSIGNMENT",
    deleteUserSubmissionsWithAssignmentFail:
      "DELETE_USER_SUBMISSIONS_WITH_ASSIGNMENT_FAIL",
    deleteUserSubmissionsWithAssignmentSuccess:
      "DELETE_USER_SUBMISSIONS_WITH_ASSIGNMENT_SUCCESS",

    getSubmission: "GET_SUBMISSION",
    getSubmissionFail: "GET_SUBMISSION_FAIL",
    getSubmissionSuccess: "GET_SUBMISSION_SUCCESS",

    listAssignmentSubmissions: "LIST_ASSIGNMENT_SUBMISSIONS",
    listAssignmentSubmissionsFail: "LIST_ASSIGNMENT_SUBMISSIONS_FAIL",
    listAssignmentSubmissionsSuccess: "LIST_ASSIGNMENT_SUBMISSIONS_SUCCESS",

    listClassSubmissions: "LIST_CLASS_SUBMISSIONS",
    listClassSubmissionsFail: "LIST_CLASS_SUBMISSIONS_FAIL",
    listClassSubmissionsSuccess: "LIST_CLASS_SUBMISSIONS_SUCCESS",

    listOrgSubmissions: "LIST_ORG_SUBMISSIONS",
    listOrgSubmissionsFail: "LIST_ORG_SUBMISSIONS_FAIL",
    listOrgSubmissionsSuccess: "LIST_ORG_SUBMISSIONS_SUCCESS",

    listUserSubmissions: "LIST_USER_SUBMISSIONS",
    listUserSubmissionsFail: "LIST_USER_SUBMISSIONS_FAIL",
    listUserSubmissionsSuccess: "LIST_USER_SUBMISSIONS_SUCCESS",

    updateSubmission: "UPDATE_SUBMISSION",
    updateSubmissionFail: "UPDATE_SUBMISSION_FAIL",
    updateSubmissionSuccess: "UPDATE_SUBMISSION_SUCCESS",
    updatePastSubmissions: "UPDATE_PAST_SUBMISSIONS",

    realTimeSubmissionSuccess: "REAL_TIME_SUBMISSIONS_SUCCESS",
  },
  pastSubmissions: {
    createPastSub: "create_past_submissions",
    createPastSubFail: "create_past_submissions_fail",
    listPastSub: "list_past_submissions",
  },

  userClasses: {
    createUserClass: "CREATE_USER_CLASS",
    createUserClassFail: "CREATE_USER_CLASS_FAIL",
    createUserClassSuccess: "CREATE_USER_CLASS_SUCCESS",

    deleteUserClass: "DELETE_USER_CLASS",
    deleteUserClassFail: "DELETE_USER_CLASS_FAIL",
    deleteUserClassSuccess: "DELETE_USER_CLASS_SUCCESS",

    listClassUsers: "LIST_CLASS_USERS",
    listClassUsersFail: "LIST_CLASS_USERS_FAIL",
    listClassUsersSuccess: "LIST_CLASS_USERS_SUCCESS",
    updateUserClassesOrder: "UPDATE_USER_CLASS_ORDER",

    listUserClasses: "LIST_USER_CLASSES",
    listUserClassesFail: "LIST_USER_CLASSES_FAIL",
    listUserClassesSuccess: "LIST_USER_CLASSES_SUCCESS",
    updateClassConfig: "update_class_config",

    setUsersByClass: "setUsersByClass",
    updateUsersByClass: "updateUsersByClass",
    clearUsersByClass: "clearUsersByClass",
  },

  users: {
    changeUserPassword: "CHANGE_USER_PASSWORD",
    changeUserPasswordSuccess: "CHANGE_USER_PASSWORD_SUCCESS",
    changeUserPasswordFail: "CHANGE_USER_PASSWORD_FAIL",

    createUser: "CREATE_USER",
    createUserFail: "CREATE_USER_FAIL",
    createUserSuccess: "CREATE_USER_SUCCESS",

    deleteUser: "DELETE_USER",
    deleteUserFail: "DELETE_USER_FAIL",
    deleteUserSuccess: "DELETE_USER_SUCCESS",

    getUser: "GET_USER",
    getUserFail: "GET_USER_FAIL",
    getUserSuccess: "GET_USER_SUCCESS",

    listUsers: "LIST_USERS",
    listUsersFail: "LIST_USERS_FAIL",
    listUsersSuccess: "LIST_USERS_SUCCESS",

    listAllUsers: "LIST_ALL_USERS",
    listAllUsersFail: "LIST_ALL_USERS_FAIL",
    listAllUsersSuccess: "LIST_ALL_USERS_SUCCESS",

    listAllStudentUsers: "LIST_ALL_STUDENT_USERS",
    listAllStudentUsersFail: "LIST_ALL_STUDENT_USERS_FAIL",
    listAllStudentUsersSuccess: "LIST_ALL_STUDENT_USERS_SUCCESS",

    listAllTeacherUsers: "LIST_ALL_TEACHER_USERS",
    listAllTeacherUsersFail: "LIST_ALL_TEACHER_USERS_FAIL",
    listAllTeacherUsersSuccess: "LIST_ALL_TEACHER_USERS_SUCCESS",

    // student constants
    listAllStudentsUsers: "LIST_ALL_STUDENTS_USERS",
    listAllStudentsUsersFail: "LIST_ALL_STUDENTS_USERS_FAIL",
    listAllStudentsUsersSuccess: "LIST_ALL_STUDENTS_USERS_SUCCESS",

    listOrgUsers: "LIST_ORGANIZATION_USERS",
    listOrgUsersFail: "LIST_ORGANIZATION_USERS_FAIL",
    listOrgUsersSuccess: "LIST_ORGANIZATION_USERS_SUCCESS",

    registerStudent: "REGISTER_STUDENT",
    registerStudentFail: "REGISTER_STUDENT_FAIL",
    registerStudentSuccess: "REGISTER_STUDENT_SUCCESS",

    updateUser: "UPDATE_USER",
    updateUserFail: "UPDATE_USER_FAIL",
    updateUserSuccess: "UPDATE_USER_SUCCESS",

    updateNewUser: "UPDATE_NEW_USER",
    updateNewUserFail: "UPDATE_NEW_USER_FAIL",
    updateNewUserSuccess: "UPDATE_NEW_USER_SUCCESS",

    userEnable: "USER_ENABLE",
    userEnableFail: "USER_ENABLE_FAIL",
    userEnableSuccess: "USER_ENABLE_SUCCESS",


    set_profile_config: "SET_PROFILE_CONFIG",
    update_profile_config: "UPDATE_PROFILE_CONFIG",
    clear_profile_config: "CLEAR_PROFILE_CONFIG",

    show_profile_pic_viewer: "SHOW_PROFILE_PHOTO_VIEWER",
    close_profile_pic_viewer: "CLOSE_PROFILE_PHOTO_VIEWER",

    list_all_district_teacher: "LIST_ALL_DISTRICT_TEACHER",

    set_class_ai_config_enabled: "SET_CLASS_AI_CONFIG_ENABLED",
  },
  user_preference: {
    createUserPrefrence: "createUserPrefrence",
    createUserPreferenceFail: "createUserPreferenceFail",
    createUserPreferencSuccess: "createUserPreferencSuccess",
    getUserPreference: "getUserPreference",
    getUserPreferencFail: "getUserPreferencFail",
    getUserPreferencSuccess: "getUserPreferencSuccess",
    updateUserPreference: "updateUserPreference",
    updateUserPreferencFail: "updateUserPreferencFail",
    updateUserPreferencSuccess: "updateUserPreferencSuccess",
  },
  selectedUser: {
    setSelectedUser: "setSelectedUser",
    setSelectedUserFail: "setSelectedUserFail",
    setSelectedUserSuccess: "setSelectedUserSuccess",
    clearSelectedUser: "clearSelectedUser",
    clearSelectedUserFail: "clearSelectedUserFail",
    clearSelectedUserSuccess: "clearSelectedUserSuccess",
  },
  schoology: {
    setAuthToken: "setAuthToken",
    setAuthTokenFail: "setAuthTokenFail",
    setAuthTokenSuccess: "setAuthTokenSuccess",
    clearAuthToken: "clearAuthToken",

    setGradeCategory: "setGradeCategory",
    setGradeCategoryFail: "setGradeCategoryFail",
    setGradeCategorySuccess: "setGradeCategorySuccess",

    setAllClassGradeCategory: "setAllClassGradeCategory",
    setAllClassGradeCategoryFail: "setAllClassGradeCategoryFail",
    setAllClassGradeCategorySuccess: "setAllClassGradeCategorySuccess",

    updateGradeCategory: "updateGradeCategory",
    updateGradeCategoryFail: "updateGradeCategoryFail",
    updateGradeCategorySuccess: "updateGradeCategorySuccess",

    setSchoologyAssignment: "setSchoologyAssignment",
    updateSchoologyAssignment: "updateSchoologyAssignment",
  },
  feedback: {
    invokeFeedback: "invokeFeedback",
    invokeFeedbackWithTeacherDescription: "invokeFeedbackWithTeacherDescription",
    revokeFeedback: "revokeFeedback",
    setFeedbackReportResult: "setFeedbackReportResult",
    clearFeedbackReportResult: "clearFeedbackReportResult",
    createFeedback: "createFeedback",
    createFeedbackFail: "createFeedbackFail",
    createFeedbackSuccess: "createFeedbackSuccess",
    getFeedback: "getFeedback",
    getFeedbackFail: "getFeedbackFail",
    getFeedbackSuccess: "getFeedbackSuccess",
  },
  multiclassStudent: {
    invokeMulticlassPopup: "invokeMulticlassPopup",
    revokeMulticlassPopup: "revokeMulticlassPopup",
    disableMulticlass: "disableMulticlass",
    disableMulticlassCreate: "disableMulticlassCreate",
    disableMulticlassFail: "disableMulticlassFail",
    disableMulticlassSuccess: "disableMulticlassSuccess",
  },
  alert: {
    invokeAlert: "invokeAlert",
    revokeAlert: "revokeAlert",

    invokeMessageAlert: "invokeMessageAlert",
    revokeMessageAlert: "revokeMessageAlert",

    invokeMainBook: "invokeMainBook",
    removeMainBook: "removeMainBook",

    invokeEbookGalleryViewer: "invokeEbookGalleryViewer",
    removeEbookGalleryView: "removeEbookGalleryView",

    invokeSentence: "invokeSentence",
    removeSentence: "removeSentence",

    invokeAiAnswer: "invokeAiAnswer",
    removeAiAnswer: "removeAiAnswer",

    invokeAnswer: "invokeAnswer",
    removeAnswer: "removeAnswer",

    invokeStory: "invokeStory",
    removeStory: "removeStory",

    invokePDF: "invokePDF",
    removePDF: "removePDF",

    invokeActivityStandards: "invokeActivityStandards",
    removeActivityStandards: "removeActivityStandards",

    invokeMatchMaking: "invokeMatchMaking",
    revokeMatchMaking: "revokeMatchMaking",
  },
  logs: {
    createLog: "CREATE_LOG",
    createLogFail: "CREATE_LOG_FAIL",
    createLogSuccess: "CREATE_LOG_SUCCESS",

    listLogs: "LIST_LOGS",
    listLogsFail: "LIST_LOGS_FAIL",
    listLogsSuccess: "LIST_LOGS_SUCCESS",

    set_active_class_logs: "SET_ACTIVE_CLASS_LOGS",
    clear_active_class_log: "CLEAR_ACTIVE_CLASS_LOG",
  },
  classlink: {
    processClasslink: "PROCESS_CLASSLINK",
    processClasslinkFail: "PROCESS_CLASSLINK_FAIL",
    processClasslinkSuccess: "PROCESS_CLASSLINK_SUCCESS",
    setTenantSuccess: "SET_SUCCESS_TENANT",
    setTenantFail: "SET_TENANT_FAIL",
  },
  resources: {
    setResourcesSuccess: "setResourcesSuccess",
    setResourcesFail: "setResourcesFail",
    setResourcesInit: "setResourcesInit",
    setVideoResourcesSuccess: "setVideoResourcesSuccess",
    setVideoResourcesFail: "setVideoResourcesFail",
    setVideoResourcesInit: "setVideoResourcesInt",
    updateResources: "updateResources",
    updateResourcesSuccess: "updateResourcesSuccess",
    updateResourcesFail: "updateVideoResourcesFail",
    updateVideoResources: "updateVideoResources",
    updateVideoResourcesSuccess: "updateVideoResourcesSuccess",
    updateVideoResourcesFail: "updateResourcesFail",
    deleteResources: "deleteResources",
    deleteResourcesSuccess: "deleteResourcesSuccess",
    deleteResourcesFail: "deleteResourcesFail"
  },
  rubric: {
    createRubric: "createRubric",
    rubricFail: "rubricFail",
    getRubric: "getRubric",
    rubricDelete: "rubricDelete",
    rubricEdit: "rubricEdit"
  },
  clever: {
    setCleverCources: "setCleverCources",
    setCleverAuthToken: "setCleverAuthToken",
    setCleverUserInfo: "setCleverUserInfo",
  },
  servertime: {
    createServerTime: "createServerTime",
    updateServertime: "updateServertime",
  },
  chat: {
    openChat: "openChat",
    users: {
      setChatUser: "setchatuser",
      updateChatUser: "updateChatUser",
      clearChatUser: "clearChatUser",
      updateChatUserConfig: "updateChatUserConfig",
    },
    status: {
      setActive: "setActive",
      deactive: "setDeactive",
    },
    message: {
      setMessage: "setMessage",
      updateMessage: "updateMessage",
      createMessage: "createMessage",
      mergeMessages: "mergeMessages",
      updateseenDelivery: "updateseenDelivery",
      messageStore: "messageStored",
      userMessageSeenUpdate: "userMessageSeenUpdate",
    },
    socket: {
      setSocket: "setSocket",
      clearSocket: "clearSocket",
      updateSocket: "updateSocket",
    },
    chatUserConfig: {
      setChatUserConfig: "setChatUserConfig",
      updateChatUserConfig: "updateUserConfig",
      clearChatUserConfig: "clearChatUserConfig",
    },
    scheduledMessage: {
      setScheduledMessage: "setScheduledMessage",
      createScheduledMessage: "createScheduledMessage",
      updateScheduledMessage: "updateScheduledMessage",
      clearScheduledMessage: "clearScheduledMessage",
      removeScheduledMessage: "removeScheduledMessage",
    },
  },
  timmer: {
    createTimmerRunning: "createTimmerRunning",
    clearTimmerRunning: "clearTimmerRunning",
  },
  exams: {
    createExams: "createExams",
    createExamsFail: "createExamsFail",
    createExamsSuccess: "createExamsSuccess",
    listExams: "listExams",
    listExamsFail: "listExamsFail",
    listExamsSuccess: "listExamsSuccess",
    updateExams: "updateExams",
    updateExamsFail: "updateExamsFail",
    updateExamsSuccess: "updateExamsSuccess",
    deleteExams: "deleteExams",
    deleteExamsFail: "deleteExamsFail",
    deleteExamsSuccess: "deleteExamsSuccess",

    set_placement_exam_list: "set_placement_exam_list",
    update_placement_exam_list: "update_placement_exam_list",
    clear_placement_exam_list: "clear_placement_exam_list",

    set_placement_submission_by_exam:"set_placement_submission_by_exam",
    update_placement_submission_by_exam:"update_placement_submission_by_exams",
    clear_placement_submission_by_exam:"clear_placement_submission_by_exams",

    set_placement_session:"set_placement_sessionm",
    set_placement_resume_session:"set_placement_resume_session",
    update_placement_session:"update_placement_session",
    clear_placement_session:"clear_placement_session",

    set_placement_exam_submission: "set_placement_exam_submission",
    update_placement_exam_submission: "update_placement_exam_submission",
    clear_placement_exam_submission: "clear_placement_exam_submission",

    set_placement_exam_distict_assignment: "set_placement_exam_distict_assignment",
    update_placement_exam_distict_assignment: "update_placement_exam_distict_assignment",
    clear_placement_exam_distict_assignment: "clear_placement_exam_distict_assignment",

    set_placement_exam_org_config :"set_placement_exam_org_config"
  },
  standardexams: {
    createStandardExams: "createStandardExams",
    createStandardExamsFail: "createStandardExamsFail",
    createStandardExamsSuccess: "createStandardExamsSuccess",
    listStandardExams: "listStandardExams",
    listStandardExamsFail: "listStandardExamsFail",
    listStandardExamsSuccess: "listStandardExamsSuccess",
    updateStandardExams: "updateStandardExams",
    updateStandardExamsFail: "updateStandardExamsFail",
    updateStandardExamsSuccess: "updateStandardExamsSuccess",
    deleteStandardExams: "deleteStandardExams",
    deleteStandardExamsFail: "deleteStandardExamsFail",
    deleteStandardExamsSuccess: "deleteStandardExamsSuccess",
  },
  apexams: {
    createApExams: "createApExams",
    createApExamsFail: "createApExamsFail",
    createApExamsSuccess: "createApExamsSuccess",
    listApExams: "listApExams",
    listApExamsFail: "listApExamsFail",
    listApExamsSuccess: "listApExamsSuccess",
    updateApExams: "updateApExams",
    updateApExamsFail: "updateApExamsFail",
    updateApExamsSuccess: "updateApExamsSuccess",
    deleteApExams: "deleteApExams",
    deleteApExamsFail: "deleteApExamsFail",
    deleteApExamsSuccess: "deleteApExamsSuccess",
  },
  wheel: {
    invokeWheelModal: "invokeWheelModal",
    revokeWheelModal: "revokeWheelModal",
    
    invokeCheckList: "invokeCheckList",
    revokeCheckList: "revokeCheckList",

    invokeNoiseMeter: "invokeNoiseMeter",
    revokeNoiseMeter: "revokeNoiseMeter",

    invokeTrafficView: "invokeTrafficView",
    revokeTrafficModal: "revokeTrafficModal",
    revokeAllWidget: "revokeAllWidget"
  },
  googleclasses: {
    setGoogleAuth: "setGoogleAuth",
    updateGoogleAuth: "updateGoogleAuth",
    clearGoogleAuth: "clearGoogleAuth",
  },
  story: {
    createStorySuccess: "createStorySuccess",
    createStoryFailure: "createStoryFailure",
    listStorySuccess: "listStorySuccess",
    listStoryFailure: "listStoryFailure",
    updateStorySuccess: "updateStorySuccess",
    updateStoryFailure: "updateStoryFailure",
    deleteStorySuccess: "deleteStorySuccess",
    deleteStoryFailure: "deleteStoryFailure",
    setStandardsSuccess: "setStandardsSuccess",
    setStandardsFailure: "setStandardsFailure",
    createStanderdsSuccess: "createStanderdsSuccess",
    updateStanderdsSuccess: "updateStanderdsSuccess",
    deleteStanderdsSuccess: "deleteStanderdsSuccess"
  },
  howToVideos: {
    createHowToVideos: "createHowToVideos",
    createHowToVideosSuccess: "createHowToVideosSuccess",
    createHowToVideosFail: "createHowToVideosFail",

    updateHowToVideosSuccess: "updateHowToVideosSuccess",
    updateHowToVideosFail: "updateHowToVideosFail",

    deleteHowToVideosSuccess: "deleteHowToVideosSuccess",
    deleteHowToVideosFail: "deleteHowToVideosFail",

    listHowToVideosSuccess: "listHowToVideosSuccess",
    listHowToVideosFail: "listHowToVideosFail",
  },
  canvas: {
    setDistrictAuth:"setDistrictAuth",
    updateDistrictAuth:"updateDistrictAuth",
    clearDistrictAuth:"clearDistrictAuth",
    setCanvasAssignmentsCategory:"setCanvasAssignmentsCategory",
    updateCanvasAssignmentsCategory:"updateCanvasAssignmentsCategory",
    cleearCanvasAssignmentsCategory:"clearCanvasAssignmentsCategory"
  },
  welcome_videos: {
    setWelcomeVideos: "setWelcomeVideos",
    updateWelcomeVideos: "updateWelcomeVideos",
  },
  booksActiveInactive: {
    listBooksActiveInactive: "LIST_BOOKS_ACTIVE_INACTIVE",
    listBooksActiveInactiveFail: "LIST_BOOKS_ACTIVE_INACTIVE_FAIL",
    listBooksActiveInactiveSuccess: "LIST_BOOKS_ACTIVE_INACTIVE_SUCCESS",

    updateBookActiveInactive: "updateBookActiveInactive",
    updateBookActiveInactiveSuccess: "updateBookActiveInactiveSuccess",
    updateBookActiveInactiveFail: "updateBookActiveInactiveFail",

    createBookActiveInactive: "createBookActiveInactive",
    createBookActiveInactiveSuccess: "createBookActiveInactiveSuccess",
    createBookActiveInactiveFail: "createBookActiveInactiveFail",
  },
  licences: {
    createLicences: "CREATE_LICENCES",
    createLicencesFail: "CREATE_LICENCES_FAIL",
    createLicencesSuccess: "CREATE_LICENCES_SUCCESS",
    listLicences: "LIST_LICENCES",
    listLicencesFail: "LIST_LICENCES_FAIL",
    listLicencesSuccess: "LIST_LICENCES_SUCCESS",
    updateLicencesSuccess: "UPDATE_LICENCES_SUCCESS",
  },
  notifications: {
    setNotification: 'SET_NOTIFICATIONS',
    createNotificationSuccess: 'CREATE_NOTIFICATION_SUCCESS',
    updateNotificationSuccess: 'UPDATE_NOTIFICATION_SUCCES',
    updateNotificationSeen: 'UPDATE_NOTIFICATION_SEEN',
    clearNotification: 'CLEAR_NOTIFICATIONS'
  },
  vocabulary: {
    listVocabulary: "LIST_VOCABULARY",
    listVocabularyFail: "LIST_VOCABULARY_FAIL",
    listVocabularySuccess: "LIST_VOCABULARY_SUCCESS",

    createVocabulary: "CREATE_VOCABULARY",
    createVocabularyFail: "CREATE_VOCABULARY_FAIL",
    createVocabularySuccess: "CREATE_VOCABULARY_SUCCESS",
    updateVocabularySuccess: "UPDATE_VOCABULARY_SUCCESS",

    deleteVocabulary: 'DELETE_VOCABULARY',
    deleteVocabularySuccess: "DELETE_VOCABULARY_SUCCESS",
   
  },
  phrases: {
    listPhrases: "LIST_PHRASES",
    listPhrasesFail: "LIST_PHRASES_FAIL",
    listPhrasesSuccess: "LIST_PHRASES_SUCCESS",

    createPhrases: "CREATE_PHRASES",
    createPhrasesFail: "CREATE_PHRASES_FAIL",
    createPhrasesSuccess: "CREATE_PHRASES_SUCCESS",
    updatePhrasesSuccess: "UPDATE_PHRASES_SUCCESS",

    deletePhrases: 'DELETE_PHRASES',
    deletePhrasesSuccess: "DELETE_PHRASES_SUCCESS",
   
  },
  vocabularyCogantes: {
    listVocabularyCogantes: "LIST_VOCABULARY_COGANTES",
    listVocabularyFailCogantes: "LIST_VOCABULARY_FAIL_COGANTES",
    listVocabularySuccessCogantes: "LIST_VOCABULARY_SUCCESS_COGANTES",

    createVocabularyCogantes: "CREATE_VOCABULARY_COGANTES",
    createVocabularyFail: "CREATE_VOCABULARY_FAIL_COGANTES",
    createVocabularySuccess: "CREATE_VOCABULARY_SUCCESS_COGANTES",
    updateVocabularySuccessCogantes: "UPDATE_VOCABULARY_SUCCESS_COGANTES",

    deleteVocabularyCogantes: 'DELETE_VOCABULARY_COGANTES',
    deleteVocabularySuccessCogantes: "DELETE_VOCABULARY_SUCCESS_COGANTES",

    createVocabularyCogantesAI: "CREATE_VOCABULARY_COGANTES_AI",
  },
  translationPractice: {
    listTranslationPracticeFail: "LIST_TRANSLATION_PRACTICE_FAIL",
    listTranslationPracticeSuccess: "LIST_TRANSLATION_PRACTICE_SUCCESS",
    updateTranslationPracticeSuccess: "UPDATE_TRANSLATION_PRACTICE_SUCCESS",
    updateTranslationPracticeFail: "UPDATE_TRANSLATION_PRACTICE_FAIL",
    deleteTranslationPractice: "DELETE_TRANSLATION_PRACTICE",
    deleteTranslationPracticeFail: "DELETE_TRANSLATION_PRACTICE_FAIL",
    deleteTranslationPracticeSuccess: "DELETE_TRANSLATION_PRACTICE_SUCCESS",
  },
  literacy_purpose:{
    setOverAll: "SET_OVER_ALL",
  },
  idea:{
    setIdea:'SET_IDEA',
    clearIdea: 'CLEAR_IDEA',
    updateIdea: 'UPDATE_IDEA',
    setIdeaModal: 'SET_IDEA_MODAL',
  },
  game:{
    list_class_game_activity: 'LIST_CLASS_GAME_ACTIVITY',
    set_player_modal: 'SET_PLAYER_MODAL',
    set_one_game_modal:'SET_ONE_GAME_MODAL',
    set_current_game_session: 'SET_CURRENT_GAME_SESSION',
    update_current_game_session:"UPDATE_CURRENT_GAME_SESSION",
    clear_current_game_session:"CLEAR_CURRENT_GAME_SESSION",

    set_class_game_activity: 'SET_CLASS_GAME_ACTIVITY',
    update_class_game_activity:"UPDATE_CLASS_GAME_ACTIVITY",
    clear_class_game_activity: "CLEAR_CLASS_GAME_ACTIVITY",
    list_class_game_activity_for_student_with_ids: "LIST_CLASS_GAME_ACTIVITY_FOR_STUDENT_WITH_IDS"
  },
  oneway_teacher: {
    create_oneway_teacher_video: "create_oneway_teacher_video",
    update_oneway_teacher_video: "update_oneway_teacher_video",
    delete_oneway_teacher_video: "deleteHowToVideosSuccess",
    list_oneway_teacher_video: "oneway_teacher_video"
  },
  one_game_video: {
    create_one_game_video: "create_one_game_video",
    update_one_game_video: "update_one_game_video",
    delete_one_game_video: "delete_one_game_video",
    list_one_game_video: "one_game_video"
  },
  one_game_category: {
    create_one_game_category: "create_one_game_category",
    update_one_game_category: "update_one_game_category",
    delete_one_game_category: "delete_one_game_category",
    list_one_game_category:  "list_one_game_category",
  },
  one_game_gallery: {
    create_one_game_gallery: "create_one_game_gallery",
    update_one_game_gallery: "update_one_game_gallery",
    delete_one_game_gallery: "delete_one_game_gallery",
    list_one_game_gallery: "one_game_gallery"
  },
  // one_game_category: {
  //   create_one_game_category: "create_one_game_category",
  //   update_one_game_category: "update_one_game_category",
  //   delete_one_game_category: "delete_one_game_category",
  //   list_one_game_category:  "list_one_game_category",
  // },
  debate:{
      invokeDebateModal: "invokeDebateModal",
      revokeDebateModal: "revokeDebateModal",
  },
  oneway_debate: {
    create_oneway_debate: "create_oneway_debate",
    update_oneway_debate: "update_oneway_debate",
    delete_oneway_debate: "deleteDebateSuccess",
    list_oneway_debate: "oneway_debate"
  },
  checkList: {
    listCheckList: "listCheckList",
    addCheckList: "addCheckList",
    deleteCheckList: "deleteCheckList",
    updateCheckList: "updateCheckList"
  },
  widgets: {
    listWidgets: "listWidgets",
    addWidgets: "addWidgets",
    deleteWidgets: "deleteWidgets",
    updateWidgets: "updateWidgets"
  },
  super_lesson: {
    listLessonSuccess: 'listLessonSuccess',
    createLessonSuccess: 'createLessonSuccess',
    updateLessonSuccess: 'updateLessonSuccess',
    deleteLessonSuccess: 'deleteLessonSuccess'
  },
  favourite_video : {
    create_favourite_video: "create_favourite_video",
    update_favourite_video: "update_favourite_video",
    list_favourite_video: "list_favourite_video",
    most_used_video: "most_used_video"
  },
  ebook_highlight: {
    set_ebook_highlight: "set_ebook_highlight",
    update_ebook_highlight: "update_ebook_highlight",
    clear_ebook_highlight: "clear_ebook_highlight"
  },
  non_native_ebook_highlight: {
    non_native_set_ebook_highlight: "non_native_set_ebook_highlight",
    non_native_update_highlight: "non_native_update_ebook_highlight",
    non_native_clear_ebook_highlight: "non_native_clear_ebook_highlight"
  },
  slide_highlighter: {
    slide_set_ebook_highlight: "slide_set_ebook_highlight",
    slide_update_ebook_highlight: "slide_update_ebook_highlight",
    slide_clear_ebook_highlight: "slide_clear_ebook_highlight"
  },
  differentiations: {
    listDifferentionLesson: 'listDifferentionLesson',
    createDifferentionLesson: 'createDifferentionLesson',
    updateDifferentionLesson: 'updateDifferentionLesson',
    deleteDifferentionLesson: 'deleteDifferentionLesson'
  },
  sentenceStarter: {
    listSenteceStarter: 'listSenteceStarter',
    createSenteceStarter: 'createSenteceStarter',
    updateSenteceStarter: 'updateSenteceStarter',
    deleteSenteceStarter: 'deleteSenteceStarter'
  },
  sentenceStarterPopup: {
    openPopup: "openPopup",
    setOpenPopup: "setOpenPopup",
    updateOpenPopup: "updateOpenPopup"
    
  },
  audioChecker: {
    getAudioCheckerInit: "getAudioCheckerInit",
    setAudioChecker: "setAudioChecker"
  },
  loaderQuizAndActivity: {
    getLoaderQuizAndActivity: "getLoaderQuizAndActivity",
    setLoaderQuizAndActivity: "setLoaderQuizAndActivity"
  },
  wordBank: {
    updateWordBank: "udpateWordBank",
    setWordBank: "setWordBank",
    deleteWordBank:"deleteWordBank",
    addWordBank: "addWordBank"
  },
  widgetWheel:{
    listUser: "listUser",
    updateUser: "updateUser",
    updateSelectedUser: "updateSelectedUser",
    updateVocabCognates: "updateVocabCognates"
  },
  widgetGroup: {
    update: "updateGroup",
  },
  widgetStation: {
    update: "updateStation",
  },
  // one_game_gallery: {
  //   create_one_game_gallery: "create_one_game_gallery",
  //   update_one_game_gallery: "update_one_game_gallery",
  //   delete_one_game_gallery: "delete_one_game_gallery",
  //   list_one_game_gallery: "one_game_gallery"
  // },
  // one_game_category: {
  //   create_one_game_category: "create_one_game_category",
  //   update_one_game_category: "update_one_game_category",
  //   delete_one_game_category: "delete_one_game_category",
  //   list_one_game_category:  "list_one_game_category",
  // },
  bingo:{
    invokeBingoModal: "invokeBingoModal",
    revokeBingoModal: "revokeBingoModal",
  },
  oneway_bingo: {
    create_oneway_bingo: "create_oneway_bingo",
    update_oneway_bingo: "update_oneway_bingo",
    delete_oneway_bingo: "deleteBingoSuccess",
    list_oneway_bingo: "oneway_bingo",
    list_teachers_bingo: "list_teachers_bingo",
    get_learning_module_count: "get_learning_module_count"
  },
  page_translations:{
    set_book_translations: "set_book_translations",
    update_book_translations: "update_book_translations",
    remove_page_translations: "remove_page_translations",
    clear_book_translations: "clear_book_translations"
  },
  grammar_content:{
    set_book_grammar_content: "set_book_grammar_content",
    update_book_grammar_content: "update_book_grammar_content",
    remove_book_grammar_content: "remove_book_grammar_content",
    clear_book_grammar_content: "clear_book_grammar_content"
  },
  vocab_content:{
    set_book_vocab_content: "set_book_vocab_content",
    update_book_vocab_content: "update_book_vocab_content",
    remove_book_vocab_content: "remove_book_vocab_content",
    clear_book_vocab_content: "clear_book_vocab_content"
  },
  cogantes:{
    set_book_cogantes: "set_book_cogantes",
    update_book_cogantes: "update_book_cogantes",
    remove_page_cogantes: "remove_page_cogantes",
    clear_book_cogantes: "clear_book_cogantes"
  },
  widgetPowerPoint: {
  },
  slides:{
    set_slides: "set_slides",
    get_slides: "get_slides",
    create_slide: "create_slide",
    update_slide: "update_slide",
    delete_slide: "delete_slide",
    delete_ebook_slide: "delete_ebook_slide",
    open_widget: "open_widget"
  },
  worksheet:{
    set_worksheet_list: "set_worksheet",
    update_worksheet_list: "update_worksheet_list",
    delete_question_by_id: "delete_question_by_id",
    update_worksheet_image: "update_worksheet_image",
    update_worksheet_image_success: "update_worksheet_image_success"
  },
  worksheetView: {
    set_worksheetView: "set_worksheetView",
  },
  previousFeedback:{
    // set_slides: "set_slides",
    // get_slides: "get_slides",
    // create_slide: "create_slide",
    // update_slide: "update_slide",
    // delete_slide: "delete_slide",
    // delete_ebook_slide: "delete_ebook_slide",
    open_widget_pfeedback: "open_widget_pfeedback"
  },
  StoryWithAi: {
    listStoryWithAi: 'listStoryWithAi',
    addStoryWithAi: 'addStoryWithAi',
    deleteStoryWithAi: 'deleteStoryWithAi',
    updateStoryWithAi: 'updateStoryWithAi',
    createClassStory: 'createClassStory',
    addOrUpdateAiStory: 'addOrUpdateAiStory',
  },
  article_level:{
    get_article_level: "get_article_level",
    update_article_level: "update_article_level",
    delete_article_level: "delete_article_level",
    create_article_level: "create_article_level",
    list_article_level: "list_article_level",
    addOrUpdateArticleLevel: "addOrUpdateArticleLevel",
  },
  whats_new: {
    create_whats_new: "create_whats_new",
    update_whats_new: "update_whats_new",
    delete_whats_new: "delete_whats_new",
    list_whats_new: "whats_new"
  },
  vocab_permission:{
    set_vocab_permission: "set_vocab_permission",
    update_vocab_permission: "update_vocab_permission",
    clear_vocab_permission: "clear_vocab_permission"
  },
  class_toggle_permission:{
    set_class_toggle_permission: "set_class_toggle_permission",
    update_class_toggle_permission: "update_class_toggle_permission",
    clear_class_toggle_permission: "clear_class_toggle_permission"
  },
  updateUI: {
    update: "update"
  },
    image_gallery: {
    create_image_gallery: "create_image_gallery",
    update_image_gallery: "update_image_gallery",
    delete_image_gallery: "delete_image_gallery",
    list_image_gallery: "list_image_gallery"
  },
  lesson_plan: {
    createOrUpdateLessonPlan: "CREATE_OR_UPDATE_LESSON_PLAN",
    createOrUpdateLessonPlanFail: "CREATE_OR_UPDATE_LESSON_PLAN_FAIL",
    createOrUpdateLessonPlanSuccess: "CREATE_OR_UPDATE_LESSON_PLAN_SUCCESS",

    deleteLessonPlan: "DELETE_LESSON_PLAN",
    deleteLessonPlanFail: "DELETE_LESSON_PLAN_FAIL",
    deleteLessonPlanSuccess: "DELETE_LESSON_PLAN_SUCCESS",

    listLessonPlanByBook: "LIST_LESSON_PLAN_BY_BOOK",
    listLessonPlanByBookFail: "LIST_LESSON_PLAN_BY_BOOK_FAIL",
    listLessonPlanByBookSuccess: "LIST_LESSON_PLAN_BY_BOOK_SUCCESS",

    listLessonPlanByBookAndUser: "LIST_LESSON_PLAN_BY_BOOK_AND_USER",
    listLessonPlanByBookAndUserFail: "LIST_LESSON_PLAN_BY_BOOK_AND_USER_FAIL",
    listLessonPlanByBookAndUserSuccess: "LIST_LESSON_PLAN_BY_BOOK_AND_USER_SUCCESS",

    setLessonPlan: "SET_LESSON_PLAN",
    updateLessonPlan: "UPDATE_LESSON_PLAN",
    clearLessonPlan: "CLEAR_LESSON_PLAN",
  },
  permissions: {
    getUserPermissions: "GET_USER_PERMISSIONS",
    getUserPermissionsSuccess: "GET_USER_PERMISSIONS_SUCCESS",
    getUserPermissionsFail: "GET_USER_PERMISSIONS_FAIL",

    updateUserPermissions: "UPDATE_USER_PERMISSIONS",
    updateUserPermissionsSuccess: "UPDATE_USER_PERMISSIONS_SUCCESS",
    updateUserPermissionsFail: "UPDATE_USER_PERMISSIONS_FAIL",

    listActivityPermissions: "LIST_ACTIVITY_PERMISSIONS",
    listActivityPermissionsSuccess: "LIST_ACTIVITY_PERMISSIONS_SUCCESS",
    listActivityPermissionsFail: "LIST_ACTIVITY_PERMISSIONS_FAIL",

    updateActivityPermissions: "UPDATE_ACTIVITY_PERMISSIONS",
    updateActivityPermissionsSuccess: "UPDATE_ACTIVITY_PERMISSIONS_SUCCESS",
    updateActivityPermissionsFail: "UPDATE_ACTIVITY_PERMISSIONS_FAIL",

    updateUser2FA: "UPDATE_USER_2FA",
    updateUser2FASuccess: "UPDATE_USER_2FA_SUCCESS",
    updateUser2FAFail: "UPDATE_USER_2FA_FAIL",

    updateUserPermissionsViaSocket: "UPDATE_USER_PERMISSIONS_VIA_SOCKET",
  },
};


export const storyData = {
  key: 'story',
  title: '1WayStory',
  description: 'Story',
  id: v4(),
  color: '',
  books: [],
  active:true,
  bookId: '',
  img: 'https://firebasestorage.googleapis.com/v0/b/yo-americano.appspot.com/o/picture%2Factivity-submissions%2F2025-08-18-e092c731-2f33-42f2-a254-8c26c8639d60Covers.jpg?alt=media&token=3128313e-f6dc-405a-ae46-80c3a30ca587',
};